<template>
  <BModal
    id="pauseConfirmation"
    ref="pauseConfirmation"
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
    hide-footer
    hide-header
    size="md"
    :centered="true"
  >
    <div class="text-center my-1">
      <img
        src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png"
        alt="Komerce"
        class="m-auto"
      >
      <div class="font-semibold text-2xl text-black my-1">
        {{ pause ? 'Pause Partner' : 'Partner Aktif Kembali' }}
      </div>
      <p class="text-black">
        {{ pause ? 'Partner meminta pause? Apakah kamu yakin untuk melakukan ini?' : 'Apakah kamu yakin untuk melakukan ini?' }}
      </p>
      <div class="flex justify-center">
        <BButton
          size="md"
          variant="outline-primary"
          class="mr-1"
          style="width: 160.5px"
          @click="$bvModal.hide('pauseConfirmation')"
        >
          Tidak
        </BButton>
        <BButton
          :disabled="loading"
          size="md"
          variant="primary"
          style="width: 160.5px"
          block
          @click="onFinish"
        >
          <BSpinner
            v-if="loading"
            small
          />
          Iya
        </BButton>
      </div>
    </div>
  </BModal>
</template>

<script>
import { komtimAxiosIns } from '@/libs/axios'
import { alertError, alertSuccess } from '@toast'

export default {
  name: 'pauseConfirmation',
  props: {
    idItem: {
      type: Number,
      default: 0,
    },
    pause: {
      type: Boolean,
    },
  },
  data() {
    return {
      loading: false,
      alertSuccess,
      alertError,
    }
  },
  methods: {
    async onFinish() {
      this.loading = true
      const data = {
        status: 'pause',
      }
      const dataActive = {
        status: 'active',
      }
      const url = `/v1/partners/${this.idItem}/update/status`
      await komtimAxiosIns.put(url, this.pause ? data : dataActive)
        .then(res => {
          const text = 'Berhasil mengubah data'
          this.alertSuccess(text)
          this.loading = false
          this.$bvModal.hide('pauseConfirmation')
        })
        .catch(err => {
          this.loading = false
          this.alertError(err)
        })
        .finally(() => this.$emit('updated'))
    },
  },
}
</script>
